import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import {
  BACKGROUND_MUSIC,
  CLICK_TAP_VO,
  CURSOR_UP,
  DEFAULT_PROMPT_TIMEOUT,
  SCENARIOS,
} from '../constants/Constants';
import { ToyboxMenu } from '../display/ToyboxMenu';
import { BtnScenarioSelect } from '../display/BtnScenarioSelect';

const BUTTON_POSITIONS = [
  { x: 594, y: 490 },
  { x: 760, y: 210 },
  { x: 1060, y: 210 },
  { x: 1245, y: 490 },
];

export default class Welcome extends SceneBase {
  constructor() {
    super({ key: KEYS.Welcome, active: false });
  }
  init(config) {
    this.completedScenario = config?.data?.completedScenario;
  }
  create() {
    super.create();
    this.add.image(910, 390, 'background_pattern');
    this.game.soundController.playMusic(BACKGROUND_MUSIC.MENU_SCREENS);

    this.toybox = new ToyboxMenu(this, 910, 750, this.game.player.getToyboxItems());
    this.toybox.on('click', this.handleOpenToybox, this);
    this.toybox.on('close', this.handleCloseToybox, this);
    this.toybox.on('select_toy', this.handleToyboxSelect, this);
    this.toybox.y = 1440;
    this.toybox.depth = 5;

    this.scenarioButtons = SCENARIOS.map((scenario, i) => {
      const btn = new BtnScenarioSelect(this, BUTTON_POSITIONS[i].x, BUTTON_POSITIONS[i].y, {
        scenarioid: scenario.id,
        id: scenario.id,
        played: this.game.player.hasPlayedScenario(scenario.id),
        active: scenario.active,
        hoverVO: scenario.nameHoverVO,
        enabled: false,
      });
      btn.once('click', this.handleScenarioSelect, this);
      btn.scale = 0;
      this.tweens.add({
        targets: btn,
        scale: { from: 0, to: 1 },
        duration: 350,
        delay: 150 * i,
        ease: Phaser.Math.Easing.Back.Out,
        onComplete: () => {
          if (i == 0) {
            this.tweens.add({
              targets: this.toybox,
              y: 750,
              delay: 100,
              ease: Phaser.Math.Easing.Back.Out,
              duration: 1000,
              onComplete: () => {
                this.startIntroVO();
                this.scenarioButtons.forEach((b) => b.enable());
                this.toybox.enable();
                this.toybox.depth = 0;
              },
            });
          }
        },
      });
      return btn;
    });
  }

  startIntroVO() {
    if (this.completedScenario) {
      this.game.vo.playChain(['NFC_1.1_5', 'NFC_1.1_6'], {
        onComplete: this.handleIntroVoComplete,
        onCompleteScope: this,
      });
    } else {
      this.game.vo.playChain(
        ['NFC_1.1_3', CLICK_TAP_VO(this.game.device.os.desktop), 'NFC_1.1_4'],
        {
          onComplete: this.handleIntroVoComplete,
          onCompleteScope: this,
        }
      );
    }

    this.promptCounter = 0;
    this.game.vo.on('vo_start', this.setPromptTimer, this);
  }

  handleIntroVoComplete() {
    this.setPromptTimer();
  }

  setPromptTimer() {
    const config = {
      delay: DEFAULT_PROMPT_TIMEOUT,
      callback: () => {
        if (this.toybox.isOpen || this.promptCounter % 2 == 1) this.toybox.triggerPrompt();
        else {
          this.game.vo.playChain([CLICK_TAP_VO(this.game.device.os.desktop), 'NFC_1.1_9']);
          this.bounceScenearioButtons();
        }
        this.promptCounter++;
      },
      loop: true,
    };
    if (this.promptTimer) {
      this.promptTimer.reset(config);
    } else {
      this.promptTimer = this.time.addEvent(config);
    }
  }

  bounceScenearioButtons() {
    this.tweens.add({
      targets: this.scenarioButtons,
      duration: 100,
      scale: { from: 1, to: 1.1 },
      yoyo: true,
      repeat: 1,
    });
  }

  handleOpenToybox() {
    this.setPromptTimer();
    this.game.soundController.playSFX('sfx', 'toys-reveal');
    this.tweens.add({
      targets: this.scenarioButtons,
      alpha: 0,
      duration: 100,
    });
    this.toybox.open();
  }

  handleCloseToybox() {
    this.game.soundController.playSFX('sfx', 'toys-away');
    this.tweens.add({
      targets: this.scenarioButtons,
      alpha: 1,
      duration: 100,
    });
  }

  handleScenarioSelect(id) {
    if (this.promptTimer) this.promptTimer.remove();
    this.toybox.disable();
    this.selectedScenario = id;
    this.scenarioButtons.forEach((btn) => {
      btn.disable();
      btn.off('click', this.handleScenarioSelect, this);
      if (btn.id == id) {
        btn.once('vocomplete', this.launchSelectedScenario, this);
      }
    });
  }

  launchSelectedScenario() {
    this.game.launchScenario(this.selectedScenario);
  }

  handleToyboxSelect(id) {
    this.game.launchInteraction(id);
  }

  shutdown() {
    this.selectedScenario = null;
    this.game.vo.off('vo_start', this.setPromptTimer, this);
    super.shutdown();
  }
}
